var _path, _path2, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 18C21 19.6569 19.657 21 18 21C16.343 21 15 19.6569 15 18C15 16.3431 16.343 15 18 15C19.657 15 21 16.3431 21 18Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6178 21.2357C4.76366 21.2357 0 16.4728 0 10.6178C0 4.76347 4.76366 -5.34058e-05 10.6178 -5.34058e-05C16.4727 -5.34058e-05 21.2357 4.76347 21.2357 10.6178C21.2357 16.4728 16.4727 21.2357 10.6178 21.2357ZM10.6178 1.36997C5.51899 1.36997 1.37062 5.5188 1.37062 10.6178C1.37062 15.7175 5.51899 19.8657 10.6178 19.8657C15.7173 19.8657 19.8657 15.7175 19.8657 10.6178C19.8657 5.5188 15.7173 1.36997 10.6178 1.36997Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.70711,
    y1: 10.2929,
    x2: 9.70711,
    y2: 14.2929,
    stroke: "white",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.29289,
    y1: 14.2929,
    x2: 15.2929,
    y2: 7.29289,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusManagement);
export default __webpack_public_path__ + "static/media/StatusManagement.073d59bd06af4476c2b400ab752fbed8.svg";
export { ForwardRef as ReactComponent };